export const environment = {
  production: true,
  environmentName: 'Development',
  baseUrl: 'https://api.tgmob-dev.prolins.com.br/api/',
  googleMapsApiKey: 'key',
}
